import {
  getGoogleFontLinks,
  getAdobeFontsLinks
} from "../linksFonts.js";
import { getCachedScript } from "../scriptCache.js";

function getFonts(pdf, fonts, format, type, site) {
  getCachedScript();

  if (fonts) {
    // jsx.js recognizes callbacks by constructor === Function, excluding async functions.
    window.jsx.evalScript(`run(getFontTemplate("${type}"));`, function (result) {
      Promise.resolve().then(() => {
        if (result) {
          const data = JSON.parse(result);
          if (!site || site === "google") {
            return getGoogleFontLinks(data, format, site);
          }
          if (site === "adobe") {
            return getAdobeFontsLinks(data, format, site);
          }
        }
      }).catch((error) => {
        alert(error.message || "Failed to collect font links");
      });
    });
  } else {
    window.jsx.evalScript("run(MAfolder(" + JSON.stringify({
      fonts: false,
      helpFile: pdf
    }) + "));")
  }
}

export default getFonts ;
